<!-- src/views/ContactUs.vue -->
<template>
  <!-- ==== CONTACTUS ====-->
  <div :class="['contact_home', language === 'cn' ? 'font-cn' : 'font-en']">
    <div class="containerContact">
      <div class="image">
        <img class="contact_image" src="@/assets/img/ContactUs/IEBPageWallpaper.png" />
      </div>
      <div class="info">
        <h2>{{ content.contact_us_title }}</h2>
        <p>{{ content.contact_us_address }}</p>
        <p>{{ content.contact_us_phone_no }}</p>
        <p>{{ content.contact_us_email }}</p>
        <p>{{ content.contact_us_patnership }}</p>
      </div>
    </div>
    <div class="note">
      <p>
        *温馨提示：如有意向与我们合作或者加入我们，请通过邮箱联系。在收到您的留言后，我们会尽快与您取得联系。
      </p>
    </div>
  </div>
</template>

<style>
/* CONTACTUS */
.containerContact {
  display: grid;
  align-items: center;
  justify-content: center;
  padding: 20px;
  grid-template-columns: repeat(2, auto);
  background-color: #fff;
  border: 1px solid #ddd;
  max-width: 800px;
  position: relative;
  margin: 0 auto;
  margin-top: 100px;
  width: 500px;
  
}
.image {
  background-color: #004080;
  width: 300px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  margin-right: 20px;
  border: 2px solid #b35a3b;
}
.contact_image {
  object-fit: cover;
}
.info {
  max-width: 300px;
}
.info h2 {
  margin-top: 0;
  color: #333;
}
.info p {
  margin: 5px 0;
  color: #333;
}
.note {
  text-align: center;
  color: #999;
  font-size: 12px;
  margin-top: 20px;
}
</style>

<script>
import { mapState } from "vuex";
import en from "@/data/contact_us_en.js";
import cn from "@/data/contact_us_cn.js";
export default {
  mixins: [en, cn],
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
  },
  watch: {
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>
